export enum RoomReservationTypeEnum {
  CURRENT = 'Current',
  PAST = 'Past',
  CANCELLED = 'Cancelled'
}
